// Centralized brand assets & content
export const ASSETS = {
  // Brand mark (logo with "The Prismatics Co.")
  logo: "https://customer-assets.emergentagent.com/job_1704cc6c-70a9-4264-a120-e5f941c0d9ea/artifacts/mjsxrvbn_IMG_6362.jpg",

  // Editorial photography
  editorial1:
    "https://customer-assets.emergentagent.com/job_prismatics-vision/artifacts/8ra1rwrj_IMG_6518.jpg", // sunset lace dress, Mykonos
  editorial2:
    "https://customer-assets.emergentagent.com/job_1704cc6c-70a9-4264-a120-e5f941c0d9ea/artifacts/o4qlqj2m_IMG_6544.jpg", // fur coat L'Avenue
  editorial3:
    "https://customer-assets.emergentagent.com/job_1704cc6c-70a9-4264-a120-e5f941c0d9ea/artifacts/q2mj5wlv_IMG_6535.jpg", // sparkling gown / Indian wedding attire

  // Additional hero editorial (4-image hero grid)
  hero2:
    "https://customer-assets.emergentagent.com/job_prismatics-vision/artifacts/7lgifmkq_IMG_6552%202.jpg", // blue dress, restaurant booth
  hero3:
    "https://customer-assets.emergentagent.com/job_prismatics-vision/artifacts/q4xo8yft_IMG_6547%202.jpg", // brown fur, Massimo Dutti night
  hero4:
    "https://customer-assets.emergentagent.com/job_prismatics-vision/artifacts/yo08tgnj_IMG_6543.jpg", // Cambridge bench afternoon

  // New lifestyle photos (from user's second upload)
  graduation:
    "https://customer-assets.emergentagent.com/job_prismatics-vision/artifacts/qxf1jxif_IMG_6538%202.jpg",
  dinner:
    "https://customer-assets.emergentagent.com/job_prismatics-vision/artifacts/7hdgfq6j_IMG_6548%202.jpg",
  cambridge:
    "https://customer-assets.emergentagent.com/job_prismatics-vision/artifacts/yo08tgnj_IMG_6543.jpg", // woman on bench in Cambridge

  // Rental / booking / terms cards
  product1:
    "https://images.unsplash.com/photo-1752974475778-c324d2af7d1e?fm=jpg&q=80&w=1600&auto=format", // clean Canon G7X product shot
  productCard:
    "https://customer-assets.emergentagent.com/job_prismatics-vision/artifacts/uxl0xij5_%231%203.PNG", // legacy promo card (kept for reference)
  productLegacy:
    "https://customer-assets.emergentagent.com/job_1704cc6c-70a9-4264-a120-e5f941c0d9ea/artifacts/3rz2zdx7_%231%202.PNG",
  howToBook:
    "https://customer-assets.emergentagent.com/job_prismatics-vision/artifacts/gjps30aq_%232%202.PNG",
  termsCard:
    "https://customer-assets.emergentagent.com/job_prismatics-vision/artifacts/uniuew32_%233%202.PNG",
};

export const CONTACT = {
  email: "prismatics.co@outlook.com",
  phone: "519-502-1904",
  phoneHref: "tel:+15195021904",
  location: "Kitchener–Waterloo & beyond",
  hours: "Open daily · 8AM – 10PM",
  social: {
    instagram: "https://www.instagram.com/prismatics.co/?hl=en",
    instagramHandle: "@prismatics.co",
    tiktok: "https://www.tiktok.com/@prismatics.co",
    tiktokHandle: "@prismatics.co",
    facebook: "https://www.facebook.com/profile.php?id=61580718865633",
    facebookHandle: "Prismatics Co.",
  },
};

// Use cases — occasions to rent for
export const OCCASIONS = [
  {
    title: "Graduations",
    blurb:
      "Caps, gowns, bouquets and the hug at the end — kept in stills that outlast the day.",
    image:
      "https://customer-assets.emergentagent.com/job_prismatics-vision/artifacts/qxf1jxif_IMG_6538%202.jpg",
    tag: "N° 01",
  },
  {
    title: "Dinner with friends",
    blurb:
      "Candlelight, clinking glasses, the laugh no one planned — small nights, film-grade.",
    image:
      "https://customer-assets.emergentagent.com/job_prismatics-vision/artifacts/7hdgfq6j_IMG_6548%202.jpg",
    tag: "N° 02",
  },
  {
    title: "Vacations",
    blurb:
      "Sunsets that go on forever, rooftops, new cities — travel-ready kits, ready when you are.",
    image:
      "https://customer-assets.emergentagent.com/job_1704cc6c-70a9-4264-a120-e5f941c0d9ea/artifacts/scpjwfl6_IMG_6518.jpg",
    tag: "N° 03",
  },
  {
    title: "Indian weddings",
    blurb:
      "Henna, haldi, baraat to bidaai — multi-day celebrations captured as the heirloom they deserve.",
    image:
      "https://customer-assets.emergentagent.com/job_1704cc6c-70a9-4264-a120-e5f941c0d9ea/artifacts/q2mj5wlv_IMG_6535.jpg",
    tag: "N° 04",
  },
  {
    title: "Nights out",
    blurb:
      "Coats, cocktails, a quiet glance. The kind of evening that wants to be remembered.",
    image:
      "https://customer-assets.emergentagent.com/job_1704cc6c-70a9-4264-a120-e5f941c0d9ea/artifacts/o4qlqj2m_IMG_6544.jpg",
    tag: "N° 05",
  },
];

// Social feed tiles — visual Instagram-style grid (links to actual account)
export const FEED_TILES = [
  {
    image:
      "https://customer-assets.emergentagent.com/job_1704cc6c-70a9-4264-a120-e5f941c0d9ea/artifacts/scpjwfl6_IMG_6518.jpg",
    caption: "Golden hour keeps its promises.",
    likes: 284,
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_prismatics-vision/artifacts/qxf1jxif_IMG_6538%202.jpg",
    caption: "Class of '26, kept in stills.",
    likes: 412,
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_1704cc6c-70a9-4264-a120-e5f941c0d9ea/artifacts/o4qlqj2m_IMG_6544.jpg",
    caption: "Sparkle, slowed down.",
    likes: 356,
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_prismatics-vision/artifacts/7hdgfq6j_IMG_6548%202.jpg",
    caption: "Dinner with friends — the real film reel.",
    likes: 198,
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_1704cc6c-70a9-4264-a120-e5f941c0d9ea/artifacts/q2mj5wlv_IMG_6535.jpg",
    caption: "Coats, cocktails, quiet glances.",
    likes: 321,
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_prismatics-vision/artifacts/uxl0xij5_%231%203.PNG",
    caption: "The instrument — Canon G7X MKIII.",
    likes: 167,
  },
];

// Terms & Conditions
export const TERMS = [
  {
    title: "Full Responsibility",
    body:
      "From pickup until return, you are fully liable for any damage, loss, or theft of the equipment.",
  },
  {
    title: "Return Conditions",
    body:
      "Late returns incur an hourly fee. All items must be returned clean, complete, and in working condition — exactly as received.",
  },
  {
    title: "ID & Cancellation Policy",
    body:
      "A valid government-issued ID is required at pickup. Cancellations must be made at least 48 hours in advance. No refunds are given after pickup.",
  },
  {
    title: "Strict Usage Rules",
    body:
      "No lending, sub-renting, or modifying the equipment. Use must remain responsible, legal, and within the agreed-upon dates.",
  },
];

// Booking steps
export const BOOKING_STEPS = [
  { n: "01", text: "Contact us with your preferred rental date." },
  { n: "02", text: "Carefully review and understand our Terms & Conditions." },
  { n: "03", text: "Complete the booking form with your details." },
  { n: "04", text: "Submit any documents we request before pickup." },
];

// Reviews
export const REVIEWS = [
  {
    name: "Aaliyah K.",
    occasion: "Convocation · University of Waterloo",
    body:
      "Booking with Prismatics was the easiest part of my whole graduation week. The G7X was spotless, the pickup was quick, and every photo from the day looks like it was pulled straight out of a magazine.",
    rating: 5,
  },
  {
    name: "Priya & Arjun",
    occasion: "Sangeet & Reception · Mississauga",
    body:
      "We rented over two nights for our sangeet and reception — the quality of every clip is unreal. Our videographer even asked what we shot on. Worth every dollar.",
    rating: 5,
  },
  {
    name: "Marcus D.",
    occasion: "Birthday dinner · Toronto",
    body:
      "Picked it up in KW, drove down for a dinner in the city, returned next morning. Zero friction. The team answered questions on IG within minutes. Already planning my next rental.",
    rating: 5,
  },
  {
    name: "Leah S.",
    occasion: "Europe trip · Mykonos, Paris, Rome",
    body:
      "Travelled across three cities with the G7X and it handled everything — boats, rooftops, low-light dinners. The included hardcase gave me peace of mind the whole way.",
    rating: 5,
  },
  {
    name: "Nadia H.",
    occasion: "Couple shoot · Cambridge",
    body:
      "Prismatics went above and beyond. They even recommended a spot for our shoot. You can tell they actually care — not just renting gear, but helping you keep the memory properly.",
    rating: 5,
  },
];
